<template>
    <div
        data-testid="step-uploadSucceeded"
        class="container container--slim step-thx-page step--upload-result--succeeded"
    >
        <h1 class="container__client-zone-header">
            {{ t(`${TRANSLATION_KEY}.header`) }}
        </h1>
        <div class="image-wrapper">
            <img
                class="w-80"
                :src="require('@/assets/ok2.svg')"
                alt="Success"
            />
        </div>
        <p class="container__subheader t-center t-bold">
            {{ t(`${TRANSLATION_KEY}.subheader`) }}
        </p>

        <div class="row">
            <SubmitButton
                data-testid="btn-uploadSucceeded-nextStep"
                :action="action.UPLOAD_SUMMARY"
                class="button button--submit"
                cy-data="go-to-personal-data"
            >
                {{ t(`${TRANSLATION_KEY}.next`) }}
            </SubmitButton>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import { useStore } from 'vuex';
import SubmitButton from '@/components/basic/buttons/SubmitButton.vue';
import { SET_STEP } from '@/constants/mutation-types';
import { Action } from '@/constants/ajax';
import { useI18n } from 'vue-i18n';

enum KeyWords {
    PATH = 'path',
    AUTOMATIC = 'automatic',
}

export default defineComponent({
    name: 'UploadSucceeded',
    components: {
        SubmitButton,
    },
    setup() {
        const store = useStore();
        const { t } = useI18n();
        const TRANSLATION_KEY = 'steps.UploadSucceeded';

        const action = Action;

        const saveInformationPath = () => {
            window.localStorage.setItem(KeyWords.PATH, KeyWords.AUTOMATIC);
        };

        const fetchDataId = () => {
            if (store.state.gbgToken && store.state.journeyId) {
                const journeyId = store.state.journeyId;
                const gbgToken = store.state.gbgToken;
                fetch(
                    `https://poc.idscan.cloud/idscanenterprisesvc/journey/get?journeyId=${journeyId}`,
                    {
                        headers: { Authorization: gbgToken },
                    }
                ).then((response: any) => {
                    response.json().then((data: any) => {
                        if (data.ProcessedDocuments) {
                            store.state.clientIdData = data.ProcessedDocuments;
                        }
                    });
                });
            }
        };

        onMounted(() => {
            saveInformationPath();
            fetchDataId();
            store.commit(SET_STEP, 'uploadSucceeded');
        });

        return {
            t,
            TRANSLATION_KEY,
            action,
        };
    },
});
</script>
